import script from "./CouponPackSupportGamePopup.vue?vue&type=script&setup=true&lang=js"
export * from "./CouponPackSupportGamePopup.vue?vue&type=script&setup=true&lang=js"

import "./CouponPackSupportGamePopup.vue?vue&type=style&index=0&id=4ca46546&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ca46546"]])

export default __exports__